<template>
  <div class="Store footerPosition">
    <menberMenu :tit-names="titNames" :tit-urls="titUrls"></menberMenu>
    <div class="mainDetailsBox StoreSkip">
      <div class="blueBtnW l">
        <i class="fa fa-AirportAround" style="margin-top: -2px"></i
        ><span style="margin-left: 5px">Air Freight</span>
      </div>
      <div class="pageChange clear l">
        <!-- <div class="l homePage" @click="jumpPage('1')">首页</div> -->
        <el-pagination
          class="l"
          style="padding: 0"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="take"
          layout="prev,pager,next"
          :total="Total"
        ></el-pagination>
        <!-- <div class="l homePage" @click="jumpPage('0')">末页</div> -->
        <el-pagination
          class="el-size l"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="take"
          layout="sizes,jumper"
          :total="Total"
        ></el-pagination>
        <div class="l Store_lineBlue">Go</div>
      </div>
    </div>
    <div style="margin-bottom: 15px">
      <div
        class="status-style"
      >
        Status：
      </div>
      <!-- <div class="status-select"> -->
        <by-en-select :optionList="statusList" :showValue="status" @getOption="getOption"></by-en-select>
      <!-- </div> -->
    </div>

    <!-- <div class="mainDetailsBox StoreContent" style="overflow: unset">
      <table
        border="0"
        cellspacing="0"
        cellpadding="0"
        width="100%"
        class="tableGrayLine"
      >
        <tr style="height: 40px">
          <th width="11%" align="center">Valid Until</th>
          <th width="14%" align="center">From</th>
          <th width="15%" align="center">To</th>
          <th width="13%" align="center">Airline</th>
          <th width="7%" align="center">T/T</th>
          <th width="9%" align="center">Total Price</th>
          <th width="8%" align="center">Status</th>
          <th width="14%" align="center">Actions</th>
        </tr>
        <tr
          style="cursor: pointer"
          v-for="(item, index) in AirPriceStoreList"
          :key="index"
          @click="reQuery(index)"
        >
          <td align="center">
            {{ new Date(item.PriceValidDate) | dateFmt("MMM DD, YYYY") }}
          </td>
          <td align="center">{{ showFrom(item) }}</td>
          <td align="center">{{ showTo(item) }}</td>
          <td align="center">
            {{ item.AirCompanyCode + "-" + item.AirCompanyCode3 }}
          </td>
          <td align="center">{{ item.ValidTerm + "Days" }}</td>
          <td align="center">{{ "US $" + item.OrderAmount }}</td>
          <td align="center">
            {{
              new Date(item.PriceValidDate).getTime() >=
              new Date(new Date().toLocaleDateString()).getTime()
                ? "Valid"
                : "Expired"
            }}
          </td>
          <td align="center">
            <a
              class="blueBtnW tishi"
              style="background: #fff; color: #004fb1 !important"
              @click.stop="reQuery(index, 'go')"
            >
              <div class="hint">
                <span>Search again</span>
                <div
                  class="floTipBox"
                  style="left: -20px; top: 35px; width: 200px"
                >
                  <i style="right: 61%"></i>
                  <p style="white-space: normal">
                    Query different airline prices under the same conditions
                  </p>
                </div>
              </div>
            </a>
            <a class="colBlue marL5" @click.stop="delTipBond(item.ID)"
              >Delete</a
            >
          </td>
        </tr>
        <tr
          v-if="!AirPriceStoreList.length"
          class="NoTr"
          style="text-align: center"
        >
          <td colspan="8">No datas</td>
        </tr>
      </table>
    </div> -->

    <!-- table -->
    <div>
      <!-- tr -->
      <div class="tr-flex">
        <!-- td -->
        <div class="td-first">
          <div class="select-copy-btn" @click="chooseAllCopy">
            <span>Copy Selected</span>
          </div>
        </div>
        <!-- td -->
        <div class="td-last">
          <div class="td-data">
            <div class="td-item" v-for="item in thList" :key="item">
                <div class="td-item-box font-bold">{{ item }}</div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="tr-flex tr-flex-1 tr-top"
        :style="{ 'margin-top': index == 0 ? '18px' : '10px' }"
        v-for="(item, index) in AirPriceStoreList"
        :key="index"
      >
        <!-- td -->
        <div class="td-first">
          <!-- 当状态为 Valid 显示 -->
          <div
            class="select-box"
            v-if="
              new Date(item.PriceValidDate).getTime() >=
              new Date(new Date().toLocaleDateString()).getTime()
            "
          >
            <div class="select-btn">
              <!-- <img
               v-if="!chooseArray.includes(item.ID)"
                @click.stop="chooseData(item)"
                src="../../../assets/img/saveQuotes/default.png"
                width="22px"
                height="22px"
              /> -->
              <svg-icon size="22" name="v"
                v-if="!chooseArray.includes(item.ID)"
                @click.stop="chooseData(item)">
                </svg-icon>
              <img
                v-else
                @click="chooseData(item)"
                src="../../../assets/img/saveQuotes/select.svg"
                width="22px"
                height="22px"
              />
              <!-- <svg-icon :size="22" name="bianzu132"
                v-else
                @click="chooseData(item)"></svg-icon> -->
            </div>
            <div class="select-copy">
              <!-- <img
                @click="requestPrice(item)"
                src="../../../assets/img/saveQuotes/copy.png"
                width="22px"
                height="22px"
              /> -->
              <svg-icon size="22" name="juxing4" @click="requestPrice(item)"></svg-icon>
            </div>
          </div>
        </div>
        <!-- td -->
        <div class="td-last" @click="getInfo(item)">
          <div class="td-data">
            <div class="td-item">
              <div class="td-item-box">
                {{ new Date(item.PriceValidDate) | dateFmt("MMM DD, YYYY") }}
              </div>
            </div>
            <div class="td-item">
              <div class="td-item-box">
                {{ showFrom(item) }}
              </div>
            </div>
            <div class="td-item">
              <div class="td-item-box">
                {{ showTo(item) }}
              </div>
            </div>
            <div class="td-item">
              <div class="td-item-box">
                {{ item.AirCompanyCode + "-" + item.AirCompanyCode3 }}
              </div>
            </div>
            <div class="td-item">
              <div class="td-item-box">
                {{ item.ValidTerm }}{{ item.ValidTerm != 1 ? "Days" : "Day" }}
              </div>
            </div>
            <div class="td-item">
              <div class="td-item-box">
                {{ "US $" + item.OrderAmount }}
              </div>
            </div>
            <div class="td-item">
              <div class="td-item-box">
                {{
                  new Date(item.PriceValidDate).getTime() >=
                  new Date(new Date().toLocaleDateString()).getTime()
                    ? "Valid"
                    : "Expired"
                }}
              </div>
            </div>
            <div class="td-item">
              <div class="td-item-box td-item-action">
                <!-- 当状态为 Valid 显示 -->
                <div
                  class="search-again"
                  v-if="
                    new Date(item.PriceValidDate).getTime() >=
                    new Date(new Date().toLocaleDateString()).getTime()
                  "
                  @click.stop="reQuery(index, 'go')"
                >
                  Re-inquire
                </div>
                <div class="delete-btn" @click.stop="delTipBond(item.ID)">
                  delete
                </div>
              </div>
            </div>
          </div>
          <!-- 费用详情 -->
          <div class="td-info" v-if="infoActive == item.ID">
            <div class="title">
              <div>Cost items</div>
              <div>Unit rate</div>
              <div>QTY</div>
              <div>Amount</div>
            </div>
            <div class="info" v-for="item in itemInfo[0] || []" :key="item.CostName">
              <div>{{ item.CostName }}</div>
              <div>US ${{ item.UnitRate }}</div>
              <div>{{ item.Quantity }}</div>
              <div>US${{ item.Amount }}</div>
            </div>
            <div class="info" v-if="itemInfo[1] && itemInfo[1].length > 0">
              <div>Local charge </div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div class="info" v-for="item in itemInfo[1] || []" :key="item.CostName">
              <div>{{ item.CostName }}</div>
              <div>US ${{ item.UnitRate }}</div>
              <div>{{ item.Quantity }}</div>
              <div>US${{ item.Amount }} <span v-if="item.MinValue">(Min US${{ item.MinValue }})</span></div>
            </div>
            <div class="info" v-if="itemInfo.length > 1">
              <div class="amount">Subtotal : US${{ getSubTotal }}</div>
            </div>
            <div class="total" :style="{ 'border-radius': !item.Remark ? '0px 0px 10px 10px' : ''}">
              <div>
                <!-- <div class="circle"></div> -->
                <div class="tishi" style="display: inline;">
                  <svg-icon name="a-Group40" size="13" style="margin-right: 11px; margin-bottom: 1px"></svg-icon>
                  <div class="floTipBox">
                      <i></i>
                    <p>If your actual shipment is different from the information provided, you may incur additional fees.</p>
                  </div>
                </div>
                
                <div class="text">Total：US${{ getTotal }}</div>
              </div>
            </div>
            <div class="remark" v-if="item.Remark != null" style="border-radius: 0px 0px 10px 10px">
              <div>Remark:</div>
              <!-- <div v-if="(items, index) in item.Remark" :key="index">{{index + 1}}.{{items}}</div> -->
              <div v-html="item.Remark.replace(/(\r\n)|(\n)/g,'<br>')"></div>
              <!-- <div>2.The above rates are based on chargeable weight on HAWB.</div>
              <div>3.For volumetric cargo, if gross weight increase or volume weight decrease, the rates will change accordingly.</div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 当没有数据时显示 -->
      <div class="tr-flex tr-top" v-if="!AirPriceStoreList.length">
        <div class="td-first"></div>
        <div class="td-last">
          <div class="td-empty">No datas</div>
        </div>
      </div>
      <!-- 数据查询加载 -->
      <!-- <div class="tr-flex tr-top" v-if="isLoading">
        <div class="td-first"></div>
        <div class="td-last">
          <div class="td-empty"><img src="@/assets/img/loading.gif" style="width:50px;height:50px;"></div>
        </div>
      </div> -->
    </div>

    <!-- 删除此报价弹框 -->
    <div class="dialogBox">
      <el-dialog
        :visible.sync="delTipBox"
        custom-class="borRad10"
        width="500px"
      >
        <div style="height: 185px; padding-top: 50px; text-align: center">
          <i
            class="fa fa-Sigh"
            style="font-size: 44px; color: rgb(244, 67, 54)"
          ></i>
          <div style="margin-top: 19px">
            Are you sure you want to delete this quotations?
          </div>
          <div style="margin-top: 50px">
            <a class="lineBtn" @click="delTipBox = false">Cancel</a>
            <a class="xblueBtn marL10" @click="defineDel">Delete</a>
          </div>
        </div>
      </el-dialog>
    </div>
    <div style="margin-bottom: 30px"></div>
    <!-- 复制报价弹框 -->
    <copy-price-dialog v-if="copyDialog" :copyDialog="copyDialog" :copyPriceData="copyPriceData" :copyPriceList="copyPriceList" @closeCopyDialog="closeCopyDialog"></copy-price-dialog>
    <!-- 复制报价， 报价更新弹框 -->
    <reuqest-price-update :requestDialog="requestDialog" @closeUpdateDialog="closeUpdateDialog"></reuqest-price-update>
  </div>
</template>
<script>
import { post, fetch, Del, put } from "@/ask/axios";
import Vue from "vue";
import menberMenu from "@/components/userCenter/public/menberPageMenu.vue";
import CopyPriceDialog from "./copyPriceDialog.vue";
import reuqestPriceUpdate from './reuqestPriceUpdate.vue'
import SvgIcon from '../../public/SvgIcon.vue';
import ByEnSelect from './byEnSelect.vue';

export default {
  components: { menberMenu, CopyPriceDialog, reuqestPriceUpdate, SvgIcon, ByEnSelect },
  data() {
    return {
      isLoading: false,
      statusList: [
        {
          label: "All",
          value: "0",
        },
        {
          label: "Valid",
          value: "1",
        },
        {
          label: "Expired",
          value: "2",
        },
      ],
      status: {
        value: 0,
        label: 'All'
      },
      thList: [
        "Valid Until",
        "From",
        "To",
        "Airline",
        "T/T",
        "Total Price",
        "Status",
        "Actions",
      ],
      api: {
        url: "",
        param: "",
        response: {},
        message: "",
      },
      titNames: "Saved Quotes",
      titUrls: "",
      skip: 1,
      take: 5,
      Total: 0,
      AirPriceStoreList: "",
      currentPage: 1,
      typeGoodsItem: "",
      delTipBox: false, //删除提示
      delID: null,
      chooseArray: [], // 复制报价
      copyDialog: false, // 更新报价弹框
      requestDialog: false,
      copyPriceData: [],
      AirPriceStoreListStatus: [],
      infoActive: -1,
      itemInfo: [],
      copyPriceList: [], // 导出报价参数
    };
  },
  created() {
    this.getAirPriceStore();
    this.getTypeCargo();
  },
  computed: {
    // 总费用 = Air Freight Cost + subtotal， subtotal是本地费扣除
    getTotal() {
      if (this.itemInfo.length == 1) {
        return this.itemInfo[0][0].Amount;
      } else if(this.itemInfo.length == 2) {
        let subArray = this.itemInfo[1];
        let subAmount = 0;
        subArray.forEach((item) => {
          subAmount += item.Amount;
        });
        return this.itemInfo[0][0].Amount + subAmount;
      } else {
        return 0;
      }
    },
    getSubTotal() {
      if (this.itemInfo.length == 2) {
        let subArray = this.itemInfo[1];
        let subAmount = 0;
        subArray.forEach((item) => {
          subAmount += item.Amount;
        });
        return subAmount;
      } else {
        return 0;
      }
    },
  },
  methods: {
    getOption(val) {
      this.status = val;
      // 页码归零
      this.skip = 1;
      // 费用明细收起
      this.infoActive = -1;
      // this.take = val;
      this.getAirPriceStore();
    },
    // 关闭报价更新弹框
    closeUpdateDialog(val) {
      this.requestDialog = false;
      // 复制报价
      if(val == 1) {
        this.copyDialog = true;
      }
    },
    // 关闭复制报价弹框
    closeCopyDialog(val) {
      this.copyDialog = false;
      if (val == 0) {
        this.chooseArray = [];
      }
    },
    // 复制报价操作
    async copyPriceAction(params) {
      let url = this.$api04 + "/Air/api/AirQueryPriceStore/GetCopyPriceStore";
      const list = {
        list: params,
      };
      this.copyPriceList = params;
      const data = await post(url, list);
      if (data.IsOK) {
        // console.log(data);
        this.copyPriceData = data.Results;
        this.copyDialog = true;

      } else {
        // 报价更新了
        this.copyPriceData = data.Results;
        this.requestDialog = true;
      }
      //console.log(this.copyPriceData);
    },
    // 复制多条数据
    chooseAllCopy() {
      // 判断是否选择了复制报价的信息
      if (this.chooseArray.length <= 0) {
        this.$message.error("please choose!");
        return false;
      }

      this.copyPriceAction(this.chooseArray);
    },
    // 复制单条数据
    async requestPrice(item) {
      // 判断是否选择了复制报价的信息
      // if (!this.chooseArray.includes(item.ID)) {
      //   this.$message.error("please choose!");
      //   return false;
      // }

      this.copyPriceAction([item.ID]);
    },
    // 选中复制报价
    chooseData(item) {
      //console.log(item);
      let id = item.ID;
      if (this.chooseArray.includes(id)) {
        let chooseIndex = this.chooseArray.indexOf(id);
        // 取消选中
        this.chooseArray.splice(chooseIndex, 1);
      } else {
        // 选中
        this.chooseArray.push(id);
      }
    },
    //弹窗是否删除框
    delTipBond(id) {
      this.delID = id; //当前删除的id
      this.delTipBox = true;
    },
    //确定删除
    defineDel() {
      this.DelQuery(this.delID);
      this.delTipBox = false;
    },

    //分页
    handleSizeChange(val) {
      this.currentPage = 1;
      this.skip = 1;
      this.take = val;
      // 费用明细收起
      this.infoActive = -1;
      this.getAirPriceStore();
    },
    handleCurrentChange(val) {
      // this.skip = (val - 1) * this.take;
      this.skip = val;
      // 费用明细收起
      this.infoActive = -1;
      this.getAirPriceStore();
    },
    //获取货物种类
    getTypeCargo() {
      let that = this;
      that.api.param = {
        AttrMain_Code: "KYSHSpecial",
      };
      // that.api.url = that.$api01 + "/api/Attribute/QueryList";
      that.api.url = that.$api04 + "/Basics/api/Attribute/QueryList";
      post(that.api.url, that.api.param).then(function (res) {
        that.typeGoodsItem = res.Results[0].valList;
        that.typeGoodsItem.forEach(item => {
          that.$set(item, "Id", item.AttrVal_ID);
        });
      });
    },

    //============start
    async getAirPriceStore() {
      let that = this;
      this.AirPriceStoreList = [];
      this.Total = 0;
      that.isLoading = true;
      // that.api.param = {
      //   storeType: 1,
      //   skip: that.skip,
      //   take: that.take,
      //   //类型 1:空运门到门 2：海运
      // };
      // that.api.url =
      //   that.$api03 +
      //   "/api/TradeCustomer/AirQueryPriceStore/GetAirQueryPriceStore";
      //   /Air
      // fetch(that.api.url, that.api.param).then(function (res) {
      //   if (res.IsOK) {
      //     that.AirPriceStoreList = res.Results;
      //     that.Total = res.Total;
      //     console.log(res.Results);
      //   }
      // });

      const url = that.$api04 + "/Air/api/AirQueryPriceStore/GetAirQueryPriceStore";

      const params = {
        storeType: 1,
        state: this.status.value,
        pageIndex: this.skip,
        pageSize: this.take,
      };

      const data = await post(url, params);
      if (data.IsOK) {
        this.AirPriceStoreList = data.Results;
        this.AirPriceStoreListStatus = data.Results.slice();
        this.Total = data.Total;
        this.isLoading = false;
      }
    },
    //删除存储查询
    DelQuery(Id) {
      let that = this;
      that.api.param = {
        delegateId: Id,
      };
      // that.api.url = that.$api03 + "/api/TradeCustomer/AirQueryPriceStore/DeleteDelegate";
      that.api.url = that.$api04 + "/Air/api/AirQueryPriceStore/DeleteDelegate";

      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK) {
          that.getAirPriceStore();
        } else {
          that.$message.error(res.Message);
        }
      });
    },
    //type 为go 时 说明时重新查询
    reQuery(index, type) {
      let that = this;
      let sessionStrogeData = {
        AirPriceStore: that.AirPriceStoreList[index],
      };
      // go 重新查询
      if (type == "go") {
        if (typeof Storage == undefined) {
          return false;
        }
        sessionStrogeData = JSON.stringify(sessionStrogeData);
        sessionStorage.setItem("AirPriceStore", sessionStrogeData);
         // 判断是否是以条款（FCA/FOB等）下单，即用户是海外同行
         let userType = JSON.parse(sessionStorage.getItem("customerInfos")).CustomerOwnerType;
         if (userType == 2) {
            window.location.href = "/checkList/quotes";
         } else {
            window.location.href = "/air/checkAirList?AirPirceStore=1";
         }
      } else {
        index = this.skip + index;
        this.$router.push({
          path: "/myInfo/myAirPriceStoreDetail",
          query: {
            id: index,
          },
        });
      }
    },
    // 获取费用明细
    getInfo(item) {
      // 显示明细, 展开收起
      this.infoActive = this.infoActive == item.ID ? -1 : item.ID;

      // 获取费用明细
      let data = item.CostItem;

      if (data.length > 0) {
        // 1 Air Freight Cost
        let firstItem = data.filter((items) => {
          return items.CostType == 1;
        });
        // 2 Local charge
        let secondItem = data.filter((items) => {
          return items.CostType == 2 || items.CostType == 3;
        });

        if ( firstItem.length > 0  && secondItem.length > 0) {
          this.itemInfo = [firstItem, secondItem];
        } else if (firstItem.length > 0  && secondItem.length <= 0) {
          this.itemInfo = [firstItem];
        } else {
          this.itemInfo = [];
        }

      }
    },
    // //渲染from 的列表
    showFrom(item) {
      if ([1, 2].includes(item.OrderServiceType)) {
        return item.StartCityNameEn + "," + item.StartProNameEn;
      } else {
        return item.DepartureCode + "," + item.DepartureNameEn;
      }
    },
    showTo(item) {
      if ([1, 4].includes(item.OrderServiceType)) {
        let Arr = item.DestAddressDesc.split(",");
        return Arr.splice(0, Arr.length - 1).join("");
      } else {
        return item.DestinationCode + "," + item.DestinationNameEn;
      }
    },
  },
};
</script>
<style scoped lang="less">
@import "../../../assets/css/details.css";
@import "../../../assets/css/userCenterCss.css";

@td-height: 50px;
@td-height-1: 80px;
.tr-flex {
  display: flex;
  flex-direction: row;


  .td-first {
    width: 85px;
    text-align: center;
  }

  .td-last {
    flex: 1;
    // position: relative;

    .td-data {
      height: @td-height;
      display: flex;
      flex-direction: row;

      position: relative;
      z-index: 10;

      background: #fff;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
      border-radius: 10px;

      .td-item {
        flex: 1;
        text-align: center;
        vertical-align: middle;

        .td-item-box {
          margin: 10px 0;
          line-height: @td-height - 2 * 10px;

          border-right: 1px solid #e6e6e6;
        }

        .font-bold {
          font-weight: 600;
        }

        .td-item-action {
          display: flex;
          justify-content: center;
          align-items: center;
          height: @td-height-1 - 2 * 10px;
        }
      }

      .td-item:last-child {
        flex: 2;
        .td-item-box {
          border: none;
        }
      }


    }

    .td-info {
      // height: 100px;
      margin: 0px 6px 0 8px;
      position: relative;
      z-index: 0;
      background: #FFFFFF;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
      border-radius: 0px 0px 10px 10px;
      // width: 100%;

      .title {
        padding: 11px 0 9px 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        div {
          flex: 1;
          padding: 0 30px;

          font-size: 14px;
          font-family: 'MicrosoftYaHei';
          color: #333333;
          line-height: 19px;
        }

         div:first-child {
           text-align: left;
         }

        div:nth-child(2), div:nth-child(3) {
          text-align: center;
        }

        div:last-child {
          text-align: right;
        }

      }

      .info {
        padding: 5px 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        border-top: 2px dashed #E2E2E2;

        div {
          flex: 1;
          padding: 0 30px;

          font-size: 12px;
          font-family: 'MicrosoftYaHei';
          color: #636363;
          line-height: 16px;
        }

        div:first-child {
          text-align: left;
        }

        div:nth-child(2), div:nth-child(3) {
          text-align: center;
        }

        div:last-child {
          text-align: right;
        }

        .amount {
          font-size: 12px;
          font-family: 'MicrosoftYaHei';
          color: #CF3737;
          line-height: 16px;
          text-align: right;
        }
      }

      .total {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding: 10px 30px;
        background: #F8FAFC;

        .circle {
          display: inline-block;
          width: 14px;
          height: 14px;
          background: #004FB1;
          border-radius: 50%;
        }

        .text {
          display: inline-block;
          font-size: 16px;
          font-family: MicrosoftYaHei;
          color: #CF3737;
          line-height: 21px;
        }
      }

      .remark {
        padding: 6px 0 20px 30px;

        div {
          margin-top: 5px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          color: #636363;
          line-height: 16px;
        }

        div:first-child {
          margin-top: 0;
        }
      }


    }

    .td-empty {
      flex: 8;
      text-align: center;
      vertical-align: middle;
      line-height: @td-height;
      background: #fff;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
    }

  }



  @action-height: 24px;

  .search-again {
    width: 100px;
    height: @action-height;
    background: #004fb1;
    border-radius: 15px;

    font-size: 12px;
    font-family: "MicrosoftYaHei";
    color: #ffffff;
    line-height: @action-height;

    cursor: pointer;
  }

  .delete-btn {
    margin-left: 20px;
    cursor: pointer;
    font-size: 13px;
    font-family: "MicrosoftYaHei";
    color: #004fb1;
    line-height: @action-height;
  }
}

.tr-flex-1 {
  // height: @td-height-1;
  cursor: pointer;

  .td-last {

    .td-data {
      height: @td-height-1;

      .td-item {
        .td-item-box {
          line-height: @td-height-1 - 2 * 10px;
        }

        .td-item-action {
          height: @td-height-1 - 2 * 10px;
        }
      }
  }
  }


}

.tr-top {
  margin-top: 10px;
}

.th-thead-style {
  display: flex;
  flex-direction: row;
  width: 100%;
}

@th-width: (100% - 85px) / 8;
.th-item {
  width: 11.875%;
  height: 50px;
  background: #ffffff;
  // box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  // border-radius: 10px;

  div {
    margin: 10px;
    border-right: 1px solid #ccc;
  }
}

.th-item:nth-child(8) {
  width: 9%;
}

.th-item:last-child {
  width: 14.75%;
}

.th-item-first {
  border-radius: 10px 0 0 10px;
}

.th-item:last-child {
  border-radius: 0 10px 10px 0;

  div {
    border: none;
  }
}

.tr-empty {
  height: 50px;
  line-height: 50px;
  background: #fff;
  border-radius: 10px;
}

.select-th-item {
  width: 65px;
  padding-right: 20px;
}

// .th-thead-style th:last-child {
//   flex: 1;
// }

.select-copy-btn {
  margin: 5px 0;
  width: 65px;
  height: 40px;
  background: #004fb1;
  border-radius: 10px;

  span {
    padding-top: 1.5px;
    font-size: 12px;
    font-family: "MicrosoftYaHei";
    color: #ffffff;
    line-height: 16px;
  }
}

.select-box {
  width: 65px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  .select-btn {
    cursor: pointer;
  }

  .select-copy {
    margin-left: 12px;
    cursor: pointer;
  }
}

.th-style {
  margin-left: 20px;
  width: 100%;
  height: 50px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.select-copy-btn:hover {
  cursor: pointer;
  opacity: 0.8;
}

.status-style {
  display: inline-block;
  width: 80px;
  font-size: 12px;
  font-family: 'MicrosoftYaHei';
  color: #333333;
  line-height: 16px;
}

.popper__arrow {
  display: none !important;
}

.status-select {
  top: 172px !important;

}

.Store {
  min-width: 1120px;
}

.StoreTop {
  background: #fff;
  border-radius: 5px;
  height: 40px;
  padding-top: 11px;
}
.pageChange {
  float: right;
}
.StoreContent {
  padding: 20px;
}
.StoreSkip {
  padding: 11px 20px;
  overflow: hidden;
}
.tableGrayLine tr td {
  height: 40px;
  border: 0;
  border-bottom: 1px solid #f6f6f6;
}
.tableGrayLine tr:hover {
  background: #deebff;
}
.NoTr:hover {
  background: #fff !important;
}
.homePage {
  height: 26px;
  width: 38px;
  text-align: center;
  line-height: 26px;
  border-radius: 5px;
  vertical-align: top;
  background: #fafafa;
  border: 1px solid #e9e9e9;
  margin: 0 3px;
  cursor: pointer;
}
.Store_lineBlue {
  width: 50px;
  height: 26px;
  text-align: center;
  line-height: 26px;
  border-radius: 30px;
  border: 1px solid #004fb1;
  color: #004fb1;
  background: #fff;
  cursor: pointer;
}
.AirBlue {
  width: 90px;
  height: 26px;
  text-align: center;
  line-height: 26px;
  border-radius: 30px;
  border: 1px solid #004fb1;
  background: #004fb1;
  color: white;
}
</style>
<style scoped>
</style>
<style >
/* .main-info::-webkit-scrollbar { */
  /*滚动条整体样式*/
  /* width: 6px; */
  /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 1px; */
/* } */

/* .main-info::-webkit-scrollbar-thumb { */
  /*滚动条里面小方块*/
  /* border-radius: 3px; */
  /* box-shadow: 0 0 5px #aaa inset;
  -webkit-box-shadow: 0 0 5px #aaa inset;
  background: #AAA;
} */

/* .main-info::-webkit-scrollbar-track { */
  /*滚动条里面轨道*/
  /* box-shadow: 0 0 5px #aaa inset;
  -webkit-box-shadow: 0 0 5px #aaa inset;
  border-radius: 3px;
  background: #fff;
} */
.Store .StoreSkip .pageChange .el-pagination button {
  border-radius: 5px;
  border: 1px solid #e9e9e9;
  background: #fafafa;
  height: 28px;
  width: 30px;
  line-height: 28px;
  margin: 0 3px;
}


.copy-dialog-style .el-dialog__body::-webkit-scrollbar {
    /*滚动条整体样式*/
  width: 6px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.copy-dialog-style .el-dialog__body::-webkit-scrollbar-thumb {
   /*滚动条里面小方块*/
  border-radius: 3px;
  box-shadow: 0 0 5px #aaa inset;
  -webkit-box-shadow: 0 0 5px #aaa inset;
  background: #AAA;
}

.copy-dialog-style .el-dialog__body::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: 0 0 5px #aaa inset;
  -webkit-box-shadow: 0 0 5px #aaa inset;
  border-radius: 3px;
  background: #fff;
}

.Store .StoreSkip .pageChange .el-pagination .number {
  border-radius: 5px;
  border: 1px solid #e9e9e9;
  background: #fafafa;
  width: 30px;
  height: 28px;
  line-height: 28px;
  margin: 0 3px;
}
.Store .el-pagination {
  padding: 0;
}
.Store .el-size .el-input input {
  height: 28px;
}
.Store .el-size .el-pagination__jump {
  margin: 0 3px;
}
.Store .el-size .el-pagination__sizes {
  margin: 0 3px;
}
.lineBtn {
  border: 1px solid #004fb1;
  border-radius: 30px;
  width: 110px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #fff;
  color: #004fb1;
  display: inline-block;
}
.xblueBtn {
  border: 1px solid #004fb1;
  border-radius: 30px;
  width: 110px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #004fb1;
  color: #fff;
  display: inline-block;
}
</style>




// WEBPACK FOOTER //
// src/components/userCenter/myInfo/myAirPriceStore.vue